(function () {
  function initTransparentHeader() {
    var headerWrap = document.querySelector('.header-wrapper');
    if (!headerWrap) return;

    var transparentEnabled = headerWrap.dataset.transparentHeader === 'true';
    var isHome = headerWrap.dataset.isHome === 'true';

    if (!transparentEnabled || !isHome) return;

    function toggleByScroll() {
      if (window.scrollY > 100) {
        headerWrap.classList.remove('header--transparent');
        headerWrap.classList.add('header--solid');
      } else {
        headerWrap.classList.add('header--transparent');
        headerWrap.classList.remove('header--solid');
      }
    }

    toggleByScroll();
    window.removeEventListener('scroll', toggleByScroll);
    window.addEventListener('scroll', toggleByScroll, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', initTransparentHeader);
  document.addEventListener('shopify:section:load', initTransparentHeader);
})();